import type { ChatAppResponse } from "../../api";

/** A completed live-data answer is already the result of the user's request. */
export function shouldOfferManualWorkflowChoice(answer: Pick<ChatAppResponse, "context" | "profile_analytics">): boolean {
    if (answer.profile_analytics) return false;

    const dataPoints: unknown = answer.context?.data_points;
    const items: unknown = Array.isArray(dataPoints)
        ? dataPoints
        : dataPoints && typeof dataPoints === "object" ? (dataPoints as { text?: unknown }).text : undefined;
    if (!Array.isArray(items)) return true;
    return !items.some(item => typeof item === "string" && item.startsWith("live/Erhol-"));
}
